import { createContext, useContext } from 'react';

const CustomerReferralContext = createContext();

CustomerReferralContext.displayName = 'CustomerReferralContext';

const useCustomerReferral = () => useContext(CustomerReferralContext);

export { CustomerReferralContext, useCustomerReferral };
